import { useState, useEffect } from "react";
import { getPatientsAll } from "../api/patient";

export function usePatientsDropdown() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await getPatientsAll({ queryKey: [null, { order_by: 'lastname, firstname' }] });
        const patientsArray = (response?.results || [])
            .sort((a, b) => {
                const nameA = `${a.lastname || ''} ${a.firstname || ''}`.toLowerCase();
                const nameB = `${b.lastname || ''} ${b.firstname || ''}`.toLowerCase();
                return nameA.localeCompare(nameB, 'es');
            });

        setPatients(patientsArray);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { patients, loading, error };
}